/**
 * @fileoverview Debounce utility for rate-limiting function calls (e.g. input handlers).
 */

/**
 * Returns a debounced version of func that runs at most once per `delay` ms.
 * @param {Function} func - Function to debounce.
 * @param {number} delay - Delay in milliseconds.
 * @returns {Function} Debounced function that preserves `this` and arguments.
 */
export const debounce = (func, delay) => {
	let inDebounce;
	return function () {
		const context = this;
		const args = arguments;
		clearTimeout(inDebounce);
		inDebounce = setTimeout(() => func.apply(context, args), delay);
	};
};
